import React, { Component } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

export const GenericTableHeader = (props) => {
    const LeftComponent = props.leftHeaderComponent || (() => <div id="header-left-filler" />)
    const RightComponent = props.rightHeaderComponent || (() => <div id="header-right-filler" />)

    const divWrapper = (component, className) => <div className={className}>{component}</div>

    return (
        <div className="header">
            {divWrapper(<LeftComponent />, "left")}
            {divWrapper(props.label, "center")}
            {divWrapper(<RightComponent />, "right")}
        </div>
    )
}

export default function GenericTable(props) {
    const Row = props.rowComponent

    const renderData = () =>
        props.data.length ? (
            props.data.map((datum, index) => (
                <Row
                    key={datum.id}
                    onLeftClick={props.onLeftClick}
                    onCenterClick={props.onCenterClick}
                    onRightClick={props.onRightClick}
                    onRowClick={props.onRowClick}
                    datum={datum}
                    index={index}
                />
            ))
        ) : (
            <div className="table-loading">{props.noDataText || "No results."}</div>
        )

    return (
        <div className={props.tableClassName}>
            <GenericTableHeader {...props} />
            <div className="body">
                {props.isLoading ? <div className="table-loading">Loading...</div> : renderData()}
            </div>
        </div>
    )
}

GenericTable.propTypes = {
    label: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    tooltipText: PropTypes.string,
    tableClassName: PropTypes.string,
    rowComponent: PropTypes.func.isRequired,
    data: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        })
    ),
    onRowClick: PropTypes.func,
    onLeftClick: PropTypes.func,
    onRightClick: PropTypes.func,
    onCenterClick: PropTypes.func,
}
